import Image from "next/image"
import Link from "next/link"
import { getSettings } from "@/core/lib/api/main/setting"
import { getMainMenu } from "@/core/lib/api/main/menu-api"

import HeaderNavAction from "./HeaderNavAction"
import HeaderNavToggle from "./HeaderNavToggle"
import HeaderNavMenu from "./HeaderNavMenu" // فقط نمایش + مگامنو
import Sidebar from "./Sidebar"

export default async function Header() {
  const [setting, mainMenu] = await Promise.all([
    getSettings(),
    getMainMenu(),
  ])

  if (!setting) {
    return <HeaderSkeleton />
  }

  return (
    <>
      <header className="m-auto sticky top-0 z-50 h-18 print:hidden bg-primary-0 text-primary-900 flex items-center justify-between px-4 py-4 sm:px-6 lg:px-12">

        <div className="flex items-center gap-5">
          <HeaderNavToggle />

          {/* لوگو دسکتاپ */}
          <Link href="/" className="hidden lg:block">
            {setting.logo_desktop && (
              <Image
                src={setting.logo_desktop}
                alt={setting.site_title || "Logo"}
                width={140}
                height={70}
                className="object-contain"
              />
            )}
          </Link>

          {/* اینجا فقط دیتا پاس میدیم — همه منطق مگامنو داخلش هست */}
          <HeaderNavMenu mainMenu={mainMenu} />
        </div>

        {/* لوگو موبایل */}
        <Link href="/" className="lg:hidden">
          {setting.logo_mobile && (
            <Image
              src={setting.logo_mobile}
              alt={setting.site_title || "Logo"}
              width={40}
              height={40}
              className="object-contain"
            />
          )}
        </Link>

        <HeaderNavAction />

      </header>

      <Sidebar
        mainItems={mainMenu}
      />
    </>
  )
}

function HeaderSkeleton() {
  return (
    <header className="sticky top-0 z-50 h-18 bg-primary-0 flex items-center justify-between px-8 py-4">
      <div className="h-12 w-32 bg-gray-300 rounded animate-pulse" />
      <div className="h-10 w-10 bg-gray-300 rounded-full animate-pulse" />
    </header>
  )
}
